// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZFk8","footer":"styles_footer__1dDzQ"};